import styled from '@emotion/styled';
import tw from 'twin.macro';

import { CustomModal } from 'components/molecules/PricingSimulator/Modals/CreateEditProjectContainer';

import { CUSTOM_LENS_UI, CUSTOM_LENS_WARNING_BANNER_STYLE, CUSTOM_LENS_SELECTION_POPOVER_CLASS } from './customLens.ui';

/**
 * Base modal shell shared by both CreateCustomLensModal and EditSystemLensModal.
 * Fixes the modal content height and tightens the header padding.
 */
export const LensModalStyled = styled(CustomModal)`
    .ant-modal-content {
        overflow: visible;
    }
    .ant-modal-title {
        ${tw`text-base leading-6 text-blackTransparent88 m-0 font-semibold`}
    }
    .ant-modal-header {
        padding: 16px !important;
        padding-bottom: 10px !important;
    }

    .${CUSTOM_LENS_SELECTION_POPOVER_CLASS} {
        .ant-popover-inner-content {
            width: 100%;
            max-width: 100%;
            padding: 0;
        }
    }
`;

/**
 * Warning banner shown inside edit-mode lens modals.
 * Informs the user that changes affect all scenarios/views using the lens.
 */
export const LensEditWarningBanner = styled.div`
    ${tw`mx-4 flex items-start gap-2 rounded-lg px-3 py-2 text-smallWord text-blackTransparent88`}
    width: ${CUSTOM_LENS_UI.EDIT_WARNING_BANNER_WIDTH}px;
    max-width: calc(100% - 32px);
    border: 1px solid ${CUSTOM_LENS_WARNING_BANNER_STYLE.borderColor};
    background-color: ${CUSTOM_LENS_WARNING_BANNER_STYLE.backgroundColor};
    align-items: center;
`;
